<template>
  <div>
    <div class="exhibitorProduct" v-if="serviceProductCaseInfo === 1">
      <div class="header">
        <div class="service_h">产品中心</div>
      </div>

      <div
        class="content_div"
        v-for="(item, index) in productList.slice(
          (pageIndex - 1) * pageSize,
          pageIndex * pageSize
        )"
        :key="index"
        @click="productInfo(item.id)"
      >
        <div class="cLeft">
          <img :src="$getSrc(item.image)" alt />
        </div>
        <div class="cRight">
          <p>{{ item.title }}</p>
          <p v-html="item.content"></p>
          <p></p>
        </div>
      </div>

      <div class="fenye">
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="productList.length"
          layout="prev, pager, next, slot "
        >
          <el-input v-model="tiaoPage" class="tiaoInp"></el-input>
          <el-button class="tiaoBtn" @click="transfer">跳转</el-button>
        </el-pagination>
      </div>
    </div>

    <div v-else>
      <exhi-product-info @frontPage="frontPage"></exhi-product-info>
    </div>
  </div>
</template>
<script>
import exhiProductInfo from "./EProductInfo";
import { mapState } from "vuex";
export default {
  props: ["exhibitorId"],
  components: {
    exhiProductInfo,
  },
  data() {
    return {
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 20, // 总条数
      productList: [],
      tiaoPage: "",
      totalIndex: 0,
      routeTreeId: "",
    };
  },
  computed: mapState([
    "serviceProductCaseInfo",
    "homeProductId",
    "treeId",
    "cloudProID",
  ]),
  activated() {},
  mounted() {
    let sessionAccountId = sessionStorage.getItem("accountId");
    this.routeTreeId = this.$route.query.t_r_i_d;
    if (this.$route.query.status === 0) {
      this.productInfo(this.homeProductId);
    } else if (this.routeTreeId) {
      this.productIdByList();
    } else if (this.$route.query.exhibitor_id) {
      this.productInfo(this.$route.query.exhibitor_id);
    } else {
      this.getProduct(sessionAccountId);
    }

  },
  watch: {
    treeId(id) {
      this.productIdByList();
    },
  },
  methods: {
    // 初始化
    getProduct(id) {
      this.$http({
        url: "getAccountIndex",
        method: "post",
        params: {
          accountId: id,
        },
      }).then(({ data }) => {
        let { code, product } = data;
        if (code === 0) {
          this.productList = product;
          this.totalIndex = product.length / this.pageSize;
        }
      });
    },

    // 产品详情
    productInfo(id) {
      this.$store.commit("SET_SERVICE_PRODUCT_CASE_INFO", 0);
      this.$store.commit("SET_HOME_PRODUCT_ID", id);
    },
    frontPage(num) {
      this.$route.query.exhibitor_id = null;
      this.$store.commit("SET_SERVICE_PRODUCT_CASE_INFO", num);
      this.$route.query.status = 1;
    },

    productIdByList() {
      let AccountId_sess = sessionStorage.getItem("accountId");
      this.$http({
        url: "getAccProductByProduct",
        method: "post",
        params: {
          accountId: AccountId_sess,
          productId: this.treeId ? this.treeId : this.routeTreeId,
        },
      }).then(({ data }) => {
        let { code, accConType1List } = data;
        if (code === 0) {
          this.productList = accConType1List;
          this.totalIndex = accConType1List.length / this.pageSize;
        }
      });
    },

    // 调转
    transfer() {
      if (this.tiaoPage * 1 > this.totalIndex) {
        this.$message.error("已超出总页数！");
      } else {
        this.pageIndex = this.tiaoPage * 1;
      }
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
  },
};
</script>
<style lang="scss">
.exhibitorProduct {
  .fenye {
    height: 32px;
    text-align: center;
    margin-top: 70px;
    .el-icon-arrow-left:before {
      content: "上一页";
    }
    .el-icon-arrow-right:before {
      content: "下一页";
    }
    .el-pagination {
      padding: 0;
    }
    .btn-prev,
    .btn-next,
    .tiaoBtn {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      line-height: 54px;
      color: #424242 !important;
    }
    .el-pager {
      li {
        width: 32px;
        height: 32px;
        background-color: #eeeeee;
        color: #525252;
        line-height: 32px;
      }
    }
    .el-pagination.is-background .el-pager li {
      &:hover {
        color: #143372;
      }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #17327e;
      &:hover {
        color: #ffffff;
      }
    }
    .tiaoInp {
      width: 32px;
      height: 32px;
      .el-input__inner {
        padding: 0;
        border-radius: 0;
        height: 32px;
      }
    }
    .tiaoBtn {
      border-radius: 2px;
      margin-left: 8px;
    }
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
      line-height: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.exhibitorProduct {
  width: 100%;
  height: 1161px;
  background-color: #ffffff;
  color: #333333;
  .header {
    width: 100%;
    height: 30px;
    line-height: 35px;
    margin-bottom: 30px;
    .service_h {
      width: 100px;
      height: 100%;
      float: left;
      font-size: 16px;
      color: #143372;
      border-top: 2px solid #143372;
      border-right: 1px solid #bbbbbb;
      text-align: center;
    }
  }
  .content_div {
    width: 825px;
    height: 140px;
    margin: 20px 0 0 22px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    .cLeft {
      width: 195px;
      height: 140px;
      background-color: #e5e5e5;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cRight {
      width: 600px;
      height: 117px;
      float: right;
      margin-top: 11px;
      p:first-child {
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
      }
      p:nth-child(2) {
        height: 36px;
        font-size: 12px;
        color: #a0a0a0;
        margin: 20px 0 32px 0;
        // text-align: left;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      p:last-child {
        font-size: 12px;
        color: #a0a0a0;
      }
    }
  }
}
</style>